// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"58":"c7b6f9b6","283":"fd67251c","291":"e683b96e","378":"21002829","430":"818484dc","433":"4f38e7ae","521":"c071d264","561":"21002829","684":"3683d713","924":"c071d264","972":"904b6717"}[chunkId] + ".chunk.css";
};